var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"multiple":"","items":[
		{ name: _vm.labelFalse, value: false },
		{ name: _vm.labelTrue, value: true }
	],"item-text":"name","item-value":"value","menu-props":{ offsetY: true }},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }